module.exports = __webpack_public_path__ + "img/icono.5bac5abf.png";